module.exports = __webpack_public_path__ + "img/icon-arrow-secondary__down.922dbd7d.svg";